import { BaseRequest } from '@/network/requests/BaseRequest'
import { jt_status } from '@/interfaces/jt_status'

export const jtStatusRequest = BaseRequest.build<jt_status>('jt_status')

export const jtStatusEnum = {
	0: {
		text: '停机',
	},
	1: {
		text: '运行',
	},
}

export const jtStatusICWEnum = {
	0: {
		text: '未检测',
	},
	1: {
		text: '检测中',
	},
	2: {
		text: '有缺陷',
	},
	3: {
		text: '有严重废',
	},
}

/**
 * 保存机台状态。
 * @param obj 机台信息对象。
 */
export function saveJTStatus(obj: jt_status) {
	if (obj._id?.$oid) {
		return jtStatusRequest.modifyById(obj._id.$oid, obj)
	} else {
		return jtStatusRequest.upload(obj)
	}
}
